import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CountrySelector = () => {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState('India');
  const [searchQuery, setSearchQuery] = useState('');

  const countries = [
    { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
    { code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸' },
    { code: 'GB', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
    { code: 'AE', name: 'UAE', dialCode: '+971', flag: '🇦🇪' },
    { code: 'SG', name: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
    { code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
    { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
    { code: 'DE', name: 'Germany', dialCode: '+49', flag: '🇩🇪' },
    { code: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷' },
    { code: 'JP', name: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  ];

  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    country.dialCode.includes(searchQuery)
  );

  const handleContinue = () => {
    const country = countries.find(c => c.name === selectedCountry);
    navigate('/register', { state: { country } });
  };

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Top Gradient Section - Dark Golden */}
      <div style={{ 
        background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
        borderBottomLeftRadius: '30px', 
        borderBottomRightRadius: '30px',
        minHeight: '130px',
        boxShadow: '0 4px 20px rgba(212, 175, 55, 0.2)'
      }}>
        <div className="container py-4">
          <div className="text-center text-dark">
            <h5 className="fw-bold" style={{ letterSpacing: '1px' }}>Select Your Country</h5>
            <p className="mb-0 opacity-75 text-dark">Choose your country to proceed with registration</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container" style={{ marginTop: '-40px' }}>
        <div className="card rounded-4 mb-4" style={{ 
          background: 'rgba(20, 20, 20, 0.95)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
        }}>
          <div className="card-body p-4">
            {/* Selected Country Preview */}
            <div className="rounded-3 p-3 mb-4" style={{ 
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.15)'
            }}>
              <small className="fw-semibold" style={{ color: '#D4AF37', letterSpacing: '1px' }}>SELECTED COUNTRY</small>
              <div className="d-flex align-items-center mt-2">
                <span className="fs-3 me-3">{countries.find(c => c.name === selectedCountry)?.flag}</span>
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-0 text-white">{selectedCountry}</h6>
                  <span style={{ color: '#D4AF37', fontWeight: 'bold' }}>
                    {countries.find(c => c.name === selectedCountry)?.dialCode}
                  </span>
                </div>
                <i className="fa fa-check-circle-fill fs-5" style={{ color: '#D4AF37' }}></i>
              </div>
            </div>

            {/* Search Bar - Dark Theme */}
            <div className="mb-4">
              <label className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                SEARCH COUNTRY
              </label>
              <div className="input-group">
                <span className="input-group-text" style={{ 
                  background: '#1a1a1a',
                  border: '1px solid rgba(212, 175, 55, 0.3)',
                  borderRight: 'none',
                  color: '#D4AF37'
                }}>
                  <i className="fa fa-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  style={{
                    background: '#1a1a1a',
                    border: '1px solid rgba(212, 175, 55, 0.3)',
                    borderLeft: 'none',
                    color: '#fff'
                  }}
                  placeholder="Search country or dial code..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery.length > 0 && (
                  <button 
                    className="btn"
                    onClick={() => setSearchQuery('')}
                    style={{ 
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderLeft: 'none',
                      color: '#D4AF37'
                    }}
                  >
                    <i className="fa fa-x"></i>
                  </button>
                )}
              </div>
            </div>

            {/* Country List */}
            <div>
              <small className="fw-semibold" style={{ color: '#D4AF37', letterSpacing: '1px' }}>AVAILABLE COUNTRIES</small>
              <div className="mt-3" style={{ maxHeight: '320px', overflowY: 'auto' }}>
                {filteredCountries.length > 0 ? (
                  filteredCountries.map((item) => (
                    <div
                      key={item.code}
                      className={`p-3 mb-2 rounded-3 ${selectedCountry === item.name ? 'active-country' : ''}`}
                      onClick={() => setSelectedCountry(item.name)}
                      style={{ 
                        cursor: 'pointer',
                        background: selectedCountry === item.name ? 'rgba(212, 175, 55, 0.1)' : 'transparent',
                        border: selectedCountry === item.name ? '1px solid rgba(212, 175, 55, 0.3)' : '1px solid transparent',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <span className="fs-4 me-3" style={{ width: '40px' }}>{item.flag}</span>
                        <div className="flex-grow-1">
                          <h6 className={`mb-0 ${selectedCountry === item.name ? 'text-golden fw-bold' : 'text-white'}`}>
                            {item.name}
                          </h6>
                          <small style={{ color: '#888' }}>Dial Code: {item.dialCode}</small>
                        </div>
                        {selectedCountry === item.name ? (
                          <i className="fa fa-circle-fill" style={{ color: '#D4AF37', fontSize: '12px' }}></i>
                        ) : (
                          <i className="fa fa-circle" style={{ color: '#555', fontSize: '12px' }}></i>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-4">
                    <i className="fa fa-search display-4" style={{ color: '#D4AF37', opacity: 0.5 }}></i>
                    <p className="mt-2" style={{ color: '#888' }}>No countries found</p>
                  </div>
                )}
              </div>
            </div>

            {/* Security Footer */}
            <div className="pt-4 mt-4" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.15)' }}>
              <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
                <span className="badge px-3 py-2" style={{ 
                  background: 'rgba(212, 175, 55, 0.1)',
                  color: '#D4AF37',
                  border: '1px solid rgba(212, 175, 55, 0.2)'
                }}>
                  <i className="fa fa-shield-check me-1"></i>
                  Secure Selection
                </span>
                <span className="badge px-3 py-2" style={{ 
                  background: 'rgba(212, 175, 55, 0.1)',
                  color: '#D4AF37',
                  border: '1px solid rgba(212, 175, 55, 0.2)'
                }}>
                  <i className="fa fa-globe me-1"></i>
                  150+ Countries
                </span>
              </div>
              <small className="d-block text-center" style={{ color: '#888' }}>
                Country selection helps us provide localized services
              </small>
            </div>
          </div>
        </div>
      </div>

      {/* Continue Button - Golden */}
      <div className="container pb-4">
        <button
          className="btn w-100 py-3"
          onClick={handleContinue}
          style={{
            background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
            border: 'none',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '1rem',
            letterSpacing: '1px',
            borderRadius: '12px',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          <i className="fa fa-arrow-right me-2"></i>
          CONTINUE WITH {selectedCountry.toUpperCase()}
        </button>
      </div>

      <style jsx>{`
        .text-golden {
          color: #D4AF37;
        }
        .active-country:hover {
          background: rgba(212, 175, 55, 0.08) !important;
          border-color: rgba(212, 175, 55, 0.2) !important;
        }
        ::-webkit-scrollbar {
          width: 6px;
        }
        ::-webkit-scrollbar-track {
          background: #1a1a1a;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #D4AF37;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #B8960C;
        }
        input:focus {
          box-shadow: none !important;
          outline: none;
        }
      `}</style>
    </div>
  );
};

export default CountrySelector;